export const platformBrand = {
  name: "聚一次",
  domain: "juyici.com",
  descriptor: "全球华人的本地活动社区",
  tagline: "一座新城，从聚一次开始。",
} as const;
